export const getApiBaseUrl = () => {
  const isDev = process.env.NODE_ENV === 'development';

  return isDev ? 'http://localhost:3000' : 'https://qwvy15tt79.execute-api.eu-central-1.amazonaws.com';
};
